import { DashboardClient } from "./_components/dashboard-client";

export default function DashboardPage() {
  return <DashboardClient />;
}
